export default [
  {
    name: 'home',
    path: '/',
    external: false,
  },
  {
    name: 'about',
    path: '/about',
    external: false,
  },
  {
    name: 'portfolio',
    path: 'https://thisiseric.netlify.app',
    external: true,
  },
  {
    name: 'github',
    path: 'https://github.com/erimaga/thekat-version-2',
    external: true,
  },
  {
    name: 'react',
    path: 'https://reactjs.org',
    external: true,
  },
];
